import { SecurityDetail } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/styledComponents.tsx';
import { EditableInfoField } from '@dealstack/frontend/shared/components/EditableInfoField/EditableInfoField.tsx';
import { DetailEditableFieldProps } from '@dealstack/frontend/shared/components/EditableInfoField/EditableInfoField.types';

export const DetailEditableField = ({
	formInput,
	editMode,
	label,
	data,
	valueDataTestId,
	style,
	shouldCapitalize,
}: Omit<DetailEditableFieldProps, 'customValueElement' | 'justifyContent'>) => {
	return (
		<EditableInfoField
			editMode={editMode}
			label={label}
			formInput={formInput}
			justifyContent="flex-end"
			customValueElement={
				<SecurityDetail
					dataTestId={valueDataTestId}
					$shouldCapitalize={shouldCapitalize}
					value={data}
				/>
			}
			style={style}
		/>
	);
};
